import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { performanceApi } from '../../api/performance';
import { PageHeader } from '../../components/PageHeader';
import { StatusBadge } from '../../components/StatusBadge';
import { SectionHeader } from '../../components/SectionHeader';
import { DataTable } from '../../components/DataTable';

const STATUS_LABELS: Record<string, string> = {
  opened: 'Opened', self_assessment: 'Awaiting Your Self-Assessment', supervisor_assessment: 'With Supervisor',
  final_rating: 'With HR', approved: 'Approved', cancelled: 'Cancelled',
};

export function MyPerformancePage() {
  const appraisalsQuery = useQuery({ queryKey: ['my-appraisals'], queryFn: () => performanceApi.myAppraisals() });

  return (
    <div className="page">
      <Link to="/staff">&larr; Back to Dashboard</Link>
      <PageHeader title="My Performance" />
      {appraisalsQuery.data && (
        <div className="panel">
          <SectionHeader title="My Appraisals" />
          <div className="panel-body">
        <DataTable
          rows={appraisalsQuery.data.data}
          rowKey={(a) => a.id}
          emptyMessage="No appraisals yet."
          columns={[
            { header: 'Cycle', render: (a) => <Link to={`/staff/performance/${a.id}`}>{a.cycle_name}</Link> },
            { header: 'Status', render: (a) => <StatusBadge status={a.status} label={STATUS_LABELS[a.status]} /> },
            { header: 'Final Rating', render: (a) => a.final_rating ?? '-' },
          ]}
        />
          </div>
        </div>
      )}
    </div>
  );
}
